/* eslint-disable import/prefer-default-export */
/**
 * @param { object } obj
 * @returns { object }
 */
export const swapKV = (obj) => Object.fromEntries(Object.entries(obj).map(([k, v]) => [v, k]));
